// properties.ts — Single source of truth for property_tag values.
// Used by /api/property/summary and PWA dropdown. Add a new property here
// when onboarding a new house; nothing else hard-codes the list.

export type PropertyTag =
  | 'Garden2A1'
  | 'Garden2A2'
  | 'GardenShared'
  | 'TinyEra'
  | 'QuanyouTianchi'
  | 'Phoenix';

export interface PropertyMeta {
  tag: PropertyTag;
  displayName: string;     // PWA dropdown label
  shortLabel: string;      // 列表卡片小標
  shared?: boolean;        // 虛擬 tag — 共用發票，需 GAS 端拆比例
}

export const PROPERTIES: PropertyMeta[] = [
  { tag: 'Garden2A1',      displayName: '花園流域 2A1',  shortLabel: '2A1' },
  { tag: 'Garden2A2',      displayName: '花園流域 2A2',  shortLabel: '2A2' },
  { tag: 'GardenShared',   displayName: '花園流域 共用', shortLabel: '共用', shared: true },
  { tag: 'TinyEra',        displayName: '小時代',        shortLabel: '小時代' },
  { tag: 'QuanyouTianchi', displayName: '全友天池',      shortLabel: '全友天池' },
  { tag: 'Phoenix',        displayName: '鳳凰城',        shortLabel: 'Phoenix' },
];

export const PROPERTY_TAGS = PROPERTIES.map((p) => p.tag);

export function isValidPropertyTag(value: unknown): value is PropertyTag {
  return typeof value === 'string' && (PROPERTY_TAGS as string[]).includes(value);
}

export const RENT_SUBCATEGORY_TO_PROPERTY: Record<string, PropertyTag> = {
  rent_a: 'Garden2A1',
  rent_b: 'Garden2A2',
  rent_c: 'TinyEra',
  rent_d: 'Phoenix',
};

export function inferPropertyTag(subcategory_id: string | null | undefined, type: string | undefined): PropertyTag | undefined {
  if (type !== 'income') return undefined;
  if (!subcategory_id) return undefined;
  return RENT_SUBCATEGORY_TO_PROPERTY[subcategory_id];
}
